import React from 'react'

const SvgCalendar = (props) => {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeMiterlimit={5}
        strokeWidth={2}
        d="M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM16 2v4M8 2v4M3 10h18"
      />
    </svg>
  )
}

export default SvgCalendar
